module.exports = __webpack_public_path__ + "img/event-2023-09-29-studio-carre.91c97d5.jpg";